// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.5C5.24 1.5 3 3.74 3 6.5C3 9.35 4.83 11.32 6.5 13C7.33 13.84 8.67 13.84 9.5 13C11.17 11.32 13 9.35 13 6.5C13 3.74 10.76 1.5 8 1.5Z',
  'M9.75 6.5C9.75 7.47 8.97 8.25 8 8.25C7.03 8.25 6.25 7.47 6.25 6.5C6.25 5.53 7.03 4.75 8 4.75C8.97 4.75 9.75 5.53 9.75 6.5Z',
];
